import api from "@/http/api";
import { useQuery, useInfiniteQuery } from "@tanstack/react-query";

const getAllGroups = (page?: number, limit?: number) => {
  const params = new URLSearchParams()
  if (page) params.append('page', page.toString())
  if (limit) params.append('limit', limit.toString())
  return api.get(`/admin/product_group?${params.toString()}`);
};

export const useGroup = () => {
  return useQuery({
    queryKey: ["product_group"],
    queryFn: async () => {
      return await getAllGroups();
    },
  });
};

export const useInfiniteGroup = (limit = 20) => {
  return useInfiniteQuery({
    queryKey: ['infinite-product_group'],
    queryFn: async ({ pageParam = 1 }) => {
      const response = await getAllGroups(pageParam, limit)
      return response.data
    },
    getNextPageParam: (lastPage) => {
      if (!lastPage || !lastPage.pagination) return undefined;
      const { currentPage, totalPages } = lastPage.pagination;
      return currentPage < totalPages ? currentPage + 1 : undefined;
    },
    initialPageParam: 1
  })
}
